import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';

const ContactBar = () => {
  const { language } = useLanguage();

  return (
    <div className="w-full py-6 px-4 shadow-md" style={{ 
      background: 'linear-gradient(135deg, #87CEEB 0%, #B0E0E6 100%)'
    }}>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-white mb-4">
          {/* Contact items with better contrast */}
          {/* Greek Phone - stays in Greek always */}
          <a href="tel:+306994411844" className="flex items-center gap-3 justify-center md:justify-start hover:opacity-80 transition-opacity bg-white/25 backdrop-blur-sm rounded-xl p-4 shadow-sm">
            <div className="bg-white/20 rounded-full p-3">
              <Phone className="w-5 h-5" />
            </div>
            <div className="text-left">
              <div className="text-xs opacity-90 mb-1 flex items-center gap-2">
                <img src="https://flagcdn.com/w40/gr.png" alt="Greece" className="w-5 h-auto" />
                <span>Ελληνικά</span>
              </div>
              <div className="text-base font-bold">+30 699 441 1844</div>
            </div>
          </a>

          {/* English Phone - stays in English always */}
          <a href="tel:+306906604673" className="flex items-center gap-3 justify-center md:justify-start hover:opacity-80 transition-opacity bg-white/25 backdrop-blur-sm rounded-xl p-4 shadow-sm">
            <div className="bg-white/20 rounded-full p-3">
              <Phone className="w-5 h-5" />
            </div>
            <div className="text-left">
              <div className="text-xs opacity-90 mb-1 flex items-center gap-2">
                <img src="https://flagcdn.com/w40/gb.png" alt="UK" className="w-5 h-auto" />
                <span>English</span>
              </div>
              <div className="text-base font-bold">+30 690 660 4673</div>
            </div>
          </a>

          {/* Email */}
          <a href="mailto:greecebay2@gmail.com" className="flex items-center gap-3 justify-center md:justify-start hover:opacity-80 transition-opacity bg-white/25 backdrop-blur-sm rounded-xl p-4 shadow-sm">
            <div className="bg-white/20 rounded-full p-3">
              <Mail className="w-5 h-5" />
            </div>
            <div className="text-left">
              <div className="text-xs opacity-90 mb-1 flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>Email</span>
              </div>
              <div className="text-sm font-bold break-all">greecebay2@gmail.com</div>
            </div>
          </a>
        </div>

        {/* Social Media Links */}
        <div className="flex items-center justify-center gap-4">
          <a 
            href="https://www.instagram.com/nea_clean/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all text-white"
          >
            <Instagram className="w-5 h-5 text-white" />
            <span className="text-sm font-semibold text-white">Instagram</span>
          </a>
          <a 
            href="https://www.facebook.com/profile.php?id=61584596424715&locale=bg_BG" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all text-white"
          >
            <Facebook className="w-5 h-5 text-white" />
            <span className="text-sm font-semibold text-white">Facebook</span>
          </a>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white">
            <MapPin className="w-4 h-4 text-white" />
            <span className="text-sm font-semibold text-white">
              {language === 'en' ? 'Athens, Greece' : 'Αθήνα, Ελλάδα'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactBar;
